import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { cleanupBodyScrollLock } from '../../utils/modalCleanup';

/** Garante que o scroll do body seja restaurado após navegação entre telas. */
export default function ScrollLockCleanup(): null {
  const location = useLocation();

  useEffect(() => {
    cleanupBodyScrollLock();
  }, [location.pathname]);

  return null;
}
